var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5919 3.78581L2.08609 10.4603L1 7.66374L20.5058 1L21.5919 3.78581ZM23 23H2.11848V10.6089H23V23ZM20.3953 3.80192V1.42253L19.0177 1.88981V4.27816L20.3953 3.80192ZM17.6515 4.74723V2.35889L16.2681 2.8208V5.22884L17.6515 4.74723ZM14.8124 5.66748V3.3042L13.4291 3.77148V6.14551L14.8124 5.66748ZM22.6132 13.2318L21.7443 10.9867H20.2714L21.1403 13.2318H22.6132ZM19.6045 13.2318L18.7357 10.9867H17.2571L18.1316 13.2318H19.6045ZM12.0476 6.67367V4.27995L10.6662 4.74723V7.13558L12.0476 6.67367ZM16.7026 13.2318L15.8337 10.9867H14.3608L15.2297 13.2318H16.7026ZM9.20856 7.58854V5.21452L7.80998 5.6818V8.07015L9.20856 7.58854ZM13.6939 13.2318L12.825 10.9867H11.3483L12.2172 13.2318H13.6939ZM6.49143 8.56966V6.17415L5.09856 6.65755V9.03158L6.49143 8.56966ZM10.7291 13.2318L9.86021 10.9867H8.38732L9.25619 13.2318H10.7291ZM3.6371 9.48454V7.11051L2.25377 7.57243V9.96615L3.6371 9.48454ZM7.73757 13.2318L6.85346 10.9867H5.392L6.24563 13.2318H7.73757ZM4.80322 13.2318L3.91911 10.9867H2.44622L3.31509 13.2318H4.80322Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/media.94e27dfcc5d39dabc8f9eeaf938c48b6.svg";